import { useQuery } from "react-query";
import { useRouter } from "../../useRouter";
import { useApiError } from "src/hooks/useApiError";
import { useState } from "react";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { getSiteNxacList, getUserNxacList } from "src/service/cloud";

interface IUseSiteNxacListProps {
  serviceUid: string;
  onSuccess?: () => void;
  onError?: () => void;
}
export function useSiteNxacList({
  serviceUid,
  onSuccess,
  onError,
}: IUseSiteNxacListProps) {
  const { handleError } = useApiError();
  const { goConsole } = useRouter();
  const [isAvailable, setIsAvailable] = useState<boolean>(false);

  // check된 Nxac정보
  const { isLoading: isLoadingSiteNxacList, data: siteNxacList } = useQuery(
    ["getSiteNxacList", getProductFromSessionStorage()],
    async () =>
      await getSiteNxacList({
        serviceUid,
      }),
    {
      enabled: serviceUid !== "",
      onSuccess: onSuccess ? onSuccess : (res) => {},
      onError: onError ? onError : handleError,
    }
  );

  return { isLoadingSiteNxacList, siteNxacList };
}
